import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, LinearProgress } from '@mui/material';

const WizardProgressBar = ({ progress, answeredQuestions, totalQuestions }) => {
  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 10,
        backgroundColor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'divider',
        py: 2,
        mb: 2,
      }}
    >
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mb: 1 }}
      >
        {answeredQuestions}/{totalQuestions} soru cevaplandı
      </Typography>

      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <LinearProgress
          variant="determinate"
          value={progress}
          color="success"
          sx={{
            width: '100%',
            height: 32,
            borderRadius: 2,
            backgroundColor: 'grey.200',
            '& .MuiLinearProgress-bar': {
              borderRadius: 2,
            },
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: 32,
          }}
        >
        <Typography
          variant="body2"
          sx={{
            fontWeight: 'bold',
            color: 'white',
            textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)',
            pointerEvents: 'none',
          }}
        >
          {progress}%
        </Typography>
        </Box>
      </Box>
    </Box>
  );
};

WizardProgressBar.propTypes = {
  progress: PropTypes.number.isRequired,
  answeredQuestions: PropTypes.number.isRequired,
  totalQuestions: PropTypes.number.isRequired,
};

export default WizardProgressBar;

